import Big from "@/plugins/big";

const calcOptions = {
  ignorePromotionalItems: false,
  ignoreDiscountRules: false,
  ignoreListPrice: false,
};

function getPrice(c, options = calcOptions) {
  if (
    !options.ignorePromotionalItems && !options.ignoreDiscountRules &&
    !options.ignoreListPrice
  ) {
    return Big(
      c.item.discountInfo?.price || c.item.listPrice ||
        c.item.promotionalPrice || c.item.price,
    );
  }
  if (
    options.ignorePromotionalItems && !options.ignoreDiscountRules &&
    !options.ignoreListPrice
  ) {
    return Big(c.item.discountInfo?.price || c.item.listPrice || c.item.price);
  }
  if (
    options.ignorePromotionalItems && options.ignoreDiscountRules &&
    options.ignoreListPrice
  ) {
    return Big(c.item.price);
  }
  if (
    options.ignorePromotionalItems && options.ignoreDiscountRules &&
    !options.ignoreListPrice
  ) {
    return Big(c.item.listPrice || c.item.price);
  }
  if (
    options.ignorePromotionalItems && !options.ignoreDiscountRules &&
    options.ignoreListPrice
  ) {
    return Big(c.item.discountInfo?.price || c.item.price);
  }
  if (
    !options.ignorePromotionalItems && options.ignoreDiscountRules &&
    options.ignoreListPrice
  ) {
    return Big(c.item.promotionalPrice || c.item.price);
  }
  if (
    !options.ignorePromotionalItems && options.ignoreDiscountRules &&
    !options.ignoreListPrice
  ) {
    return Big(c.item.listPrice || c.item.promotionalPrice || c.item.price);
  }
  if (
    !options.ignorePromotionalItems && !options.ignoreDiscountRules &&
    options.ignoreListPrice
  ) {
    return Big(
      c.item.discountInfo?.price || c.item.promotionalPrice || c.item.price,
    );
  }
  return Big(c.item.price);
}

export function calcTotal(items, options = calcOptions) {
  return items.reduce((a, c) => {
    const acc = Big(a);
    const price = getPrice(c, options);
    const quantity = Big(c.quantity);
    return acc.add(price.mul(quantity)).toFixedNumber();
  }, 0);
}

export function calcTotalWithoutPromoItems(items, options = calcOptions) {
  options.ignorePromotionalItems = true;
  return items.filter((v) => !v.item?.promotionalPrice).reduce((a, c) => {
    const acc = Big(a);
    const price = getPrice(c, options);
    const quantity = Big(c.quantity);
    return acc.add(price.mul(quantity)).toFixedNumber();
  }, 0);
}

// Sufixo e ícone do rótulo de desconto, derivados do meio de pagamento da regra.
// Regra única para os dois contextos de exibição, com duas variantes de texto:
// - "short" (item: vitrine, card, busca, PDP, carrinho) — só a regra padrão é
//   anunciada, então o tipo `pix` aparece curto ("5% desconto PIX");
// - "full" (checkout) — a lista pode trazer mais de uma regra de PIX na mesma
//   loja ("PIX na entrega", "Pagar com PIX"), e o label do meio de pagamento é
//   o que distingue uma da outra.
// O ícone não varia por contexto (só o checkout o consome).
const getPaymentDiscountDisplay = (payment, variant) => {
  const billingType = payment.type === "gateway" && payment.supportedTypes
    ? JSON.parse(payment.supportedTypes)[0]
    : null;

  if (payment.type === "pix" && variant === "short") {
    return { suffix: "PIX", icon: "mdi-cash-fast" };
  }

  if (["card", "simple", "pix"].includes(payment.type)) {
    return {
      suffix: payment.label,
      icon: payment.type === "card"
        ? "mdi-credit-card-fast-outline"
        : "mdi-cash-fast",
    };
  }

  if (billingType === "pix") {
    return { suffix: "no PIX", icon: "mdi-rhombus-split" };
  }

  return {
    suffix: variant === "short" ? "no cartão" : "no Cartão",
    icon: "mdi-credit-card-outline",
  };
};

export const getDiscountInfo = (data, discountRule) => {
  const currentItem = data?.item || data;

  if (!currentItem || !discountRule) {
    return data;
  }

  // Sem preço utilizável (ex.: modo "somente PJ" oculta os preços dos itens
  // para visitantes) não há desconto a calcular. Evita `Big(null)`, que
  // lançaria e impediria a renderização do card do item.
  const basePrice = currentItem.listPrice || currentItem.promotionalPrice ||
    currentItem.price;
  if (basePrice == null) {
    return data;
  }

  const item = { ...currentItem };
  const price = Big(basePrice);
  const rule = discountRule;
  const payment = rule.paymentMethod;

  const r = {
    price,
    discountValue: Big(rule.discountValue),
    discountType: rule.discountType,
    label: payment.label,
  };

  if (rule.discountType === "percentage") {
    const discount = price.mul(r.discountValue.div(100));
    r.price = price.sub(discount);
    r.label = `${Math.floor(r.discountValue.toNumber())}% desconto`;
  } else {
    r.price = price.sub(r.discountValue);
    r.label = `${globalThis.$utils.BRL(r.discountValue.toNumber())}`;
  }

  const { suffix } = getPaymentDiscountDisplay(payment, "short");
  r.label = `${r.label} ${suffix}`;

  r.price = r.price.toNumber();
  r.discountValue = r.discountValue.toNumber();

  item.discountInfo = r;
  if (data.item) {
    data.item = item;
    return data;
  }
  return item;
};

export const getDiscountLabel = (discountRule, subtotal) => {
  const payment = discountRule.paymentMethod;
  const discountValue = Big(discountRule.discountValue);
  let title = payment.label;
  let total = Big(subtotal);

  if (discountRule.discountType === "percentage") {
    const discount = total.mul(discountValue.div(100));
    total = total.sub(discount);
    title = `${Math.floor(discountValue.toNumber())}% desconto`;
  } else {
    total = total.sub(discountValue);
    title = `${globalThis.$utils.BRL(discountValue.toNumber())}`;
  }

  const { suffix, icon } = getPaymentDiscountDisplay(payment, "full");

  return { title: `${title} ${suffix}`, icon, total: total.toNumber() };
};
